[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 8,
                "y": 11,
                "key": "i1otH"
            },
            {
                "x": 8,
                "y": 8,
                "key": "NBPXU"
            },
            {
                "x": 9,
                "y": 8,
                "key": "UmGU9e9DGAW2cgtDM5LDE"
            },
            {
                "x": 9,
                "y": 7,
                "key": "6dIxq"
            },
            {
                "x": 12,
                "y": 7,
                "key": "gTp5H"
            },
            {
                "x": 12,
                "y": 11,
                "key": "tgAlOo15-hexJ72EDJs-g"
            }
        ]
    },
    {
        "key": "a",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 0,
                "y": 27,
                "key": "5nuYE"
            },
            {
                "x": 0,
                "y": 24,
                "key": "5o8So"
            },
            {
                "x": 0,
                "y": 23,
                "key": "ZnnhK"
            },
            {
                "x": 1,
                "y": 23,
                "key": "bNtxu"
            },
            {
                "x": 4,
                "y": 23,
                "key": "1I0KQ"
            },
            {
                "x": 4,
                "y": 24,
                "key": "KLVei"
            },
            {
                "x": 5,
                "y": 24,
                "key": "zenGA"
            },
            {
                "x": 5,
                "y": 25,
                "key": "n7th-"
            },
            {
                "x": 5,
                "y": 25,
                "key": "qBsI8"
            },
            {
                "x": 6,
                "y": 25,
                "key": "FsLsJ"
            },
            {
                "x": 6,
                "y": 26,
                "key": "TWFtG"
            },
            {
                "x": 5,
                "y": 26,
                "key": "2IlVu"
            },
            {
                "x": 5,
                "y": 27,
                "key": "FTmHU"
            },
            {
                "x": 4,
                "y": 27,
                "key": "iivw-"
            },
            {
                "x": 4,
                "y": 28,
                "key": "p9BDa"
            },
            {
                "x": 1,
                "y": 28,
                "key": "76XTu"
            },
            {
                "x": 1,
                "y": 27,
                "key": "aBmEQ"
            }
        ]
    },
    {
        "key": "b",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 6,
                "y": 23,
                "key": "-6Z1T"
            },
            {
                "x": 9,
                "y": 23,
                "key": "_rXc4"
            },
            {
                "x": 9,
                "y": 24,
                "key": "2GRH3"
            },
            {
                "x": 10,
                "y": 24,
                "key": "XRQrI"
            },
            {
                "x": 10,
                "y": 25,
                "key": "hV4HL"
            },
            {
                "x": 11,
                "y": 25,
                "key": "qyHra"
            },
            {
                "x": 11,
                "y": 26,
                "key": "Qyf5_"
            },
            {
                "x": 10,
                "y": 26,
                "key": "yoe8o"
            },
            {
                "x": 10,
                "y": 27,
                "key": "9RG4o"
            },
            {
                "x": 9,
                "y": 27,
                "key": "S8i3r"
            },
            {
                "x": 9,
                "y": 28,
                "key": "x8eAC"
            },
            {
                "x": 6,
                "y": 28,
                "key": "km6nR"
            }
        ]
    },
    {
        "key": "c",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 11,
                "y": 23,
                "key": "EWSR1"
            },
            {
                "x": 14,
                "y": 23,
                "key": "EEZPQ"
            },
            {
                "x": 14,
                "y": 24,
                "key": "jZTPu"
            },
            {
                "x": 15,
                "y": 24,
                "key": "jbfwz"
            },
            {
                "x": 15,
                "y": 25,
                "key": "zJNmh"
            },
            {
                "x": 16,
                "y": 25,
                "key": "Wr4FT"
            },
            {
                "x": 16,
                "y": 26,
                "key": "RhhGb"
            },
            {
                "x": 15,
                "y": 26,
                "key": "gsWwo"
            },
            {
                "x": 15,
                "y": 27,
                "key": "BtNiE"
            },
            {
                "x": 11,
                "y": 27,
                "key": "kvPeo"
            }
        ]
    },
    {
        "key": "d",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 16,
                "y": 23,
                "key": "pX2uX"
            },
            {
                "x": 19,
                "y": 23,
                "key": "n2p8j"
            },
            {
                "x": 19,
                "y": 24,
                "key": "Fnpu3"
            },
            {
                "x": 20,
                "y": 24,
                "key": "2Mxoh"
            },
            {
                "x": 20,
                "y": 25,
                "key": "NDyEI"
            },
            {
                "x": 21,
                "y": 25,
                "key": "1Cva3"
            },
            {
                "x": 21,
                "y": 25,
                "key": "lnHBp"
            },
            {
                "x": 22,
                "y": 25,
                "key": "lRDFN"
            },
            {
                "x": 22,
                "y": 26,
                "key": "oJwAD"
            },
            {
                "x": 21,
                "y": 26,
                "key": "84sov"
            },
            {
                "x": 21,
                "y": 28,
                "key": "jLr5C"
            },
            {
                "x": 16,
                "y": 28,
                "key": "nlD3w"
            }
        ]
    },
    {
        "key": "e",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 22,
                "y": 23,
                "key": "zQaGy"
            },
            {
                "x": 25,
                "y": 23,
                "key": "sR1_q"
            },
            {
                "x": 25,
                "y": 24,
                "key": "IuE43"
            },
            {
                "x": 26,
                "y": 24,
                "key": "zOWeM"
            },
            {
                "x": 26,
                "y": 25,
                "key": "x0BUu"
            },
            {
                "x": 27,
                "y": 25,
                "key": "u7WgX"
            },
            {
                "x": 27,
                "y": 26,
                "key": "GzpPr"
            },
            {
                "x": 23,
                "y": 26,
                "key": "jawby"
            },
            {
                "x": 23,
                "y": 27,
                "key": "YDDBu"
            },
            {
                "x": 22,
                "y": 27,
                "key": "kD42u"
            },
            {
                "x": 22,
                "y": 26,
                "key": "ROop8"
            }
        ]
    },
    {
        "key": "f",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 27,
                "y": 23,
                "key": "tzzCr"
            },
            {
                "x": 30,
                "y": 23,
                "key": "lyj3k"
            },
            {
                "x": 30,
                "y": 24,
                "key": "6Mo3K"
            },
            {
                "x": 31,
                "y": 24,
                "key": "Fa-gE"
            },
            {
                "x": 31,
                "y": 25,
                "key": "vALw6"
            },
            {
                "x": 30,
                "y": 25,
                "key": "JTKBs"
            },
            {
                "x": 30,
                "y": 25,
                "key": "u9wXC"
            },
            {
                "x": 30,
                "y": 26,
                "key": "RJZn-"
            },
            {
                "x": 28,
                "y": 26,
                "key": "f_Rzf"
            },
            {
                "x": 28,
                "y": 27,
                "key": "ncF1t"
            },
            {
                "x": 27,
                "y": 27,
                "key": "W_ifZ"
            },
            {
                "x": 27,
                "y": 26,
                "key": "Z-Dv7"
            }
        ]
    },
    {
        "key": "g",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 31,
                "y": 23,
                "key": "TdUQb"
            },
            {
                "x": 34,
                "y": 23,
                "key": "e0WUh"
            },
            {
                "x": 34,
                "y": 25,
                "key": "NRl9E"
            },
            {
                "x": 35,
                "y": 25,
                "key": "SzrqV"
            },
            {
                "x": 35,
                "y": 26,
                "key": "0XvAK"
            },
            {
                "x": 34,
                "y": 26,
                "key": "42F51"
            },
            {
                "x": 34,
                "y": 27,
                "key": "B2SXd"
            },
            {
                "x": 31,
                "y": 27,
                "key": "-o8sK"
            }
        ]
    },
    {
        "key": "h",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 35,
                "y": 23,
                "key": "Z2lpi"
            },
            {
                "x": 38,
                "y": 23,
                "key": "L5rnJ"
            },
            {
                "x": 38,
                "y": 25,
                "key": "wgEE6"
            },
            {
                "x": 39,
                "y": 25,
                "key": "iCDca"
            },
            {
                "x": 39,
                "y": 26,
                "key": "yLGXj"
            },
            {
                "x": 38,
                "y": 26,
                "key": "t0Mgk"
            },
            {
                "x": 38,
                "y": 28,
                "key": "8ipiK"
            },
            {
                "x": 35,
                "y": 28,
                "key": "WDMKJ"
            }
        ]
    }
]